<template>
  <footer class="ods-footer">
    <div class="ods-footer__gutter">
      <div class="ods-footer__content">
        <div class="ods-grid ods-grid--gap">
          <div
            v-for="(content, contentIndex) in contentList"
            :key="`content-${contentIndex}`"
            class="ods-grid__column--12 ods-grid__column--4-breakpoint-medium"
          >
            <h2
              class="ods-text--size-india ods-text--size-hotel-breakpoint-medium ods-text--size-golf-breakpoint-large ods-text--weight-medium ods-margin-bottom-4"
            >
              {{ content.header }}
            </h2>
            <ul class="ods-unordered-list ods-unordered-list--clean">
              <li
                v-for="(link, linkIndex) in content.links"
                :key="`content-${contentIndex}-link-${linkIndex}`"
                class="ods-unordered-list__item"
              >
                <a :href="link.href" class="ods-link ods-link--chevron-right ods-link--state-light"> {{ link.text }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'OdsFooter',
  props: {
    contentList: {
      type: Array,
      required: true,
    },
  },
};
</script>
